module.exports = __webpack_public_path__ + "img/telp.97cf8290.svg";